// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"banner-medium-item_image-wrapper__ljHcU","image":"banner-medium-item_image__H_kzf"};